// extracted by mini-css-extract-plugin
module.exports = {"countDownContainer":"countDown_countDownContainer__3INKO","CountDownLayout":"countDown_CountDownLayout__298qT","progressBarCircle":"countDown_progressBarCircle__1lQXu"};